<div
  #container
  class="w-full overflow-auto"
  [style.paddingBottom.rem]="paddingBottomInRem"
>
  <div class="relative min-w-fit max-w-full">
    <svg #svgContainer class="absolute inset-0 size-full"></svg>
    <ng-content></ng-content>
  </div>
</div>
